export const validator = async ({ values }) => {
  const errors: { [key: string]: any } = {};

  if (!values.amount?.trim()) {
    errors.amount = "Amount is required";
  } else {
    if (isNaN(values.amount) || +values.amount <= 0) {
      errors.amount = "Amount is not valid";
    } else if (values.amount.trim().split(".")[1]?.length > 2) {
      errors.amount = "Max 2 digits allowed after decimal point";
    } else if (+values.amount >= 10e15) {
      errors.amount = "Maximum limit exceeded";
    }
  }

  if (!values.currency) {
    errors.currency = "Currency is required";
  }

  if (Object.keys(errors).length > 0) {
    throw errors;
  }
};
